/* eslint-disable react/jsx-key */
import React from 'react';
import { Colors } from 'modules/theme';

export const ICONS = {
  eye: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0696354 13.0152C1.94456 8.25745 6.57395 4.88184 12 4.88184C17.4261 4.88184 22.0554 8.25745 23.9304 13.0152C24.0232 13.2508 24.0232 13.5129 23.9304 13.7485C22.0554 18.5062 17.4261 21.8818 12 21.8818C6.57395 21.8818 1.94456 18.5062 0.0696355 13.7485C-0.0232118 13.5129 -0.0232118 13.2508 0.0696354 13.0152ZM2.08269 13.3818C3.75589 17.2092 7.56631 19.8818 12 19.8818C16.4337 19.8818 20.2441 17.2092 21.9173 13.3818C20.2441 9.55446 16.4337 6.88184 12 6.88184C7.56631 6.88184 3.75589 9.55446 2.08269 13.3818ZM8 13.3818C8 11.1696 9.78771 9.38184 12 9.38184C14.2123 9.38184 16 11.1696 16 13.3818C16 15.5941 14.2123 17.3818 12 17.3818C9.78771 17.3818 8 15.5941 8 13.3818ZM12 11.3818C10.8923 11.3818 10 12.2741 10 13.3818C10 14.4896 10.8923 15.3818 12 15.3818C13.1077 15.3818 14 14.4896 14 13.3818C14 12.2741 13.1077 11.3818 12 11.3818Z"
        fill="#051528"
      />,
    ],
  },
  eye_blocked: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.29292 22.293C1.9024 21.9025 1.9024 21.2694 2.29292 20.8788L19.8787 3.29304C20.2692 2.90252 20.9024 2.90252 21.2929 3.29304C21.6834 3.68357 21.6834 4.31673 21.2929 4.70726L3.70714 22.293C3.31661 22.6836 2.68345 22.6836 2.29292 22.293Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.04984 18.9502C7.05116 20.2467 9.43669 21 12 21C17.4261 21 22.0554 17.6244 23.9304 12.8666C24.0232 12.631 24.0232 12.369 23.9304 12.1334C22.8512 9.39482 20.8594 7.11419 18.3284 5.67164L16.8514 7.14861C19.1011 8.2817 20.9024 10.1784 21.9173 12.5C20.2441 16.3274 16.4337 19 12 19C9.99289 19 8.11351 18.4523 6.50231 17.4977L5.04984 18.9502ZM8.93142 15.0686C9.66465 15.9441 10.7663 16.5 12 16.5C14.2123 16.5 16 14.7123 16 12.5C16 11.2663 15.4441 10.1647 14.5686 9.43142L13.1431 10.8569C13.6617 11.2176 14 11.8179 14 12.5C14 13.6077 13.1077 14.5 12 14.5C11.3179 14.5 10.7176 14.1617 10.3569 13.6431L8.93142 15.0686ZM12.6235 8.54811L8.04811 13.1235C8.01644 12.9203 8 12.7121 8 12.5C8 10.2877 9.78771 8.5 12 8.5C12.2121 8.5 12.4203 8.51644 12.6235 8.54811ZM14.8039 6.36767C13.9096 6.12785 12.9697 6 12 6C7.56631 6 3.75589 8.67262 2.08269 12.5C2.72417 13.9674 3.67978 15.265 4.86422 16.3073L3.4478 17.7238C1.97412 16.4004 0.808183 14.7408 0.0696355 12.8666C-0.0232118 12.631 -0.0232118 12.369 0.0696354 12.1334C1.94456 7.37562 6.57395 4 12 4C13.5451 4 15.0257 4.27373 16.3964 4.77516L14.8039 6.36767Z"
        fill="#808B99"
      />,
    ],
  },
  checked: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7241 8.31035C18.105 8.71028 18.0896 9.34325 17.6897 9.72414L11.3897 15.7241C11.1941 15.9104 10.9314 16.0097 10.6615 15.9993C10.3916 15.9889 10.1374 15.8697 9.95671 15.669L7.25671 12.669C6.88726 12.2585 6.92053 11.6262 7.33104 11.2567C7.74155 10.8872 8.37384 10.9205 8.7433 11.331L10.7552 13.5665L16.3104 8.27586C16.7103 7.89498 17.3433 7.91042 17.7241 8.31035Z"
        fill="white"
      />,
    ],
  },
  image: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3.75C4.30964 3.75 3.75 4.30964 3.75 5V19C3.75 19.6904 4.30964 20.25 5 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V5C20.25 4.30964 19.6904 3.75 19 3.75H5ZM2.25 5C2.25 3.48122 3.48122 2.25 5 2.25H19C20.5188 2.25 21.75 3.48122 21.75 5V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 7.75C8.08579 7.75 7.75 8.08579 7.75 8.5C7.75 8.91421 8.08579 9.25 8.5 9.25C8.91421 9.25 9.25 8.91421 9.25 8.5C9.25 8.08579 8.91421 7.75 8.5 7.75ZM6.25 8.5C6.25 7.25736 7.25736 6.25 8.5 6.25C9.74264 6.25 10.75 7.25736 10.75 8.5C10.75 9.74264 9.74264 10.75 8.5 10.75C7.25736 10.75 6.25 9.74264 6.25 8.5Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5199 9.42384C15.8204 9.17344 16.2628 9.196 16.5363 9.47567L20.9363 13.9757C21.2259 14.2718 21.2205 14.7467 20.9244 15.0363C20.6282 15.3258 20.1533 15.3205 19.8638 15.0243L15.948 11.0196L4.48016 20.5762C4.16195 20.8413 3.68903 20.7984 3.42385 20.4801C3.15868 20.1619 3.20167 19.689 3.51988 19.4238L15.5199 9.42384Z"
        fill="#808B99"
      />,
    ],
  },
  close: {
    paths: [
      <path
        d="M18 6L6 18"
        stroke="#051528"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M6 6L18 18"
        stroke="#051528"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  company: {
    fill: 'none',
    viewBox: '0 0 16 16',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6666 4.6665C13.6666 3.9265 13.0733 3.33317 12.3333 3.33317H9.66659V1.99984C9.66659 1.25984 9.07325 0.666504 8.33325 0.666504H5.66659C4.92659 0.666504 4.33325 1.25984 4.33325 1.99984V3.33317H1.66659C0.926585 3.33317 0.339919 3.9265 0.339919 4.6665L0.333252 11.9998C0.333252 12.7398 0.926585 13.3332 1.66659 13.3332H12.3333C13.0733 13.3332 13.6666 12.7398 13.6666 11.9998V4.6665ZM8.33325 3.33317V1.99984H5.66658V3.33317H8.33325ZM1.66659 4.6665V11.9998H12.3333V4.6665H1.66659Z"
        fill="#808B99"
      />,
    ],
  },
  facebookLink: {
    viewBox: '0 0 25 24',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.043 0C5.39184 0 0 5.37258 0 12C0 18.6274 5.39184 24 12.043 24C18.6942 24 24.086 18.6274 24.086 12C24.086 5.37258 18.6942 0 12.043 0ZM13.2983 12.5271V19.0557H10.5874V12.5274H9.233V10.2776H10.5874V8.92678C10.5874 7.0914 11.3521 6 13.5249 6H15.3338V8.25006H14.2031C13.3573 8.25006 13.3014 8.56447 13.3014 9.15125L13.2983 10.2773H15.3466L15.107 12.5271H13.2983Z"
        fill="#526275"
      />,
    ],
  },
  instagramLink: {
    viewBox: '0 0 25 24',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2149 0C5.56372 0 0.171875 5.37258 0.171875 12C0.171875 18.6274 5.56372 24 12.2149 24C18.8661 24 24.2579 18.6274 24.2579 12C24.2579 5.37258 18.8661 0 12.2149 0ZM9.56702 5.63865C10.2521 5.60758 10.4711 5.59998 12.2154 5.59998H12.2134C13.9584 5.59998 14.1765 5.60758 14.8616 5.63865C15.5454 5.66985 16.0124 5.77772 16.4218 5.93599C16.8447 6.09932 17.202 6.31799 17.5592 6.67399C17.9165 7.02973 18.136 7.3868 18.3006 7.80774C18.4585 8.21468 18.5669 8.67975 18.599 9.36109C18.6297 10.0438 18.6378 10.2619 18.6378 12C18.6378 13.7382 18.6297 13.9558 18.599 14.6385C18.5669 15.3196 18.4585 15.7848 18.3006 16.1918C18.136 16.6126 17.9165 16.9697 17.5592 17.3254C17.2024 17.6814 16.8446 17.9006 16.4222 18.0641C16.0136 18.2224 15.5463 18.3302 14.8625 18.3614C14.1774 18.3925 13.9592 18.4001 12.2146 18.4001C10.4704 18.4001 10.2516 18.3925 9.56649 18.3614C8.88284 18.3302 8.41597 18.2224 8.0073 18.0641C7.58512 17.9006 7.22677 17.6814 6.86989 17.3254C6.51275 16.9697 6.29329 16.6126 6.12911 16.1917C5.9704 15.7848 5.86215 15.3197 5.8307 14.6383C5.79966 13.9557 5.7919 13.7382 5.7919 12C5.7919 10.2619 5.79993 10.0436 5.83057 9.36095C5.86135 8.67988 5.96974 8.21468 6.12897 7.80761C6.29356 7.3868 6.51302 7.02973 6.8703 6.67399C7.22731 6.31812 7.58566 6.09945 8.0081 5.93599C8.4165 5.77772 8.88324 5.66985 9.56702 5.63865Z"
        fill="#526275"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.639 6.75355C11.7509 6.75338 11.8713 6.75343 12.0012 6.75349L12.2152 6.75355C13.9302 6.75355 14.1334 6.75969 14.8107 6.79035C15.4369 6.81889 15.7768 6.92315 16.0032 7.01076C16.3029 7.12676 16.5166 7.26543 16.7413 7.48943C16.9661 7.71343 17.1053 7.92677 17.222 8.22544C17.3099 8.45077 17.4147 8.78944 17.4432 9.41345C17.4739 10.0881 17.4806 10.2908 17.4806 11.9988C17.4806 13.7068 17.4739 13.9095 17.4432 14.5842C17.4145 15.2082 17.3099 15.5468 17.222 15.7722C17.1056 16.0709 16.9661 16.2835 16.7413 16.5074C16.5165 16.7314 16.3031 16.8701 16.0032 16.9861C15.7771 17.0741 15.4369 17.1781 14.8107 17.2066C14.1336 17.2373 13.9302 17.2439 12.2152 17.2439C10.5002 17.2439 10.2969 17.2373 9.61981 17.2066C8.99356 17.1778 8.65368 17.0735 8.42713 16.9859C8.12739 16.8699 7.91329 16.7313 7.68849 16.5073C7.46368 16.2833 7.32452 16.0705 7.20783 15.7716C7.11992 15.5463 7.01514 15.2076 6.98664 14.5836C6.95586 13.909 6.94971 13.7063 6.94971 11.9972C6.94971 10.2881 6.95586 10.0865 6.98664 9.41185C7.01528 8.78784 7.11992 8.44917 7.20783 8.22357C7.32425 7.9249 7.46368 7.71156 7.68849 7.48756C7.91329 7.26356 8.12739 7.12489 8.42713 7.00862C8.65354 6.92062 8.99356 6.81662 9.61981 6.78795C10.2123 6.76129 10.442 6.75329 11.639 6.75195V6.75355ZM15.6438 7.8162C15.2183 7.8162 14.873 8.1598 14.873 8.58394C14.873 9.00794 15.2183 9.35195 15.6438 9.35195C16.0693 9.35195 16.4145 9.00794 16.4145 8.58394C16.4145 8.15993 16.0693 7.81593 15.6438 7.81593V7.8162ZM8.91678 12.0003C8.91678 10.1853 10.3936 8.71368 12.2151 8.71361C14.0367 8.71361 15.5132 10.1852 15.5132 12.0003C15.5132 13.8154 14.0369 15.2863 12.2153 15.2863C10.3937 15.2863 8.91678 13.8154 8.91678 12.0003Z"
        fill="#526275"
      />,
      <path
        d="M12.2157 9.8667C13.3981 9.8667 14.3567 10.8218 14.3567 12.0001C14.3567 13.1782 13.3981 14.1334 12.2157 14.1334C11.0332 14.1334 10.0747 13.1782 10.0747 12.0001C10.0747 10.8218 11.0332 9.8667 12.2157 9.8667Z"
        fill="#526275"
      />,
    ],
  },
  linkedinLink: {
    viewBox: '0 0 25 24',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.129 0C5.47778 0 0.0859375 5.37258 0.0859375 12C0.0859375 18.6274 5.47778 24 12.129 24C18.7801 24 24.172 18.6274 24.172 12C24.172 5.37258 18.7801 0 12.129 0ZM5.86743 9.93888H8.59664V18.1097H5.86743V9.93888ZM8.77631 7.41135C8.7586 6.6102 8.18364 6 7.24999 6C6.31635 6 5.70596 6.6102 5.70596 7.41135C5.70596 8.1959 6.29831 8.82367 7.21457 8.82367H7.23201C8.18364 8.82367 8.77631 8.1959 8.77631 7.41135ZM15.2968 9.74704C17.0928 9.74704 18.4392 10.9151 18.4392 13.4248L18.4391 18.1098H15.71V13.7384C15.71 12.6403 15.315 11.8911 14.327 11.8911C13.573 11.8911 13.1239 12.3962 12.9267 12.8841C12.8545 13.0589 12.8368 13.3025 12.8368 13.5467V18.11H10.1073C10.1073 18.11 10.1432 10.7058 10.1073 9.93913H12.8368V11.0965C13.199 10.5401 13.8478 9.74704 15.2968 9.74704Z"
        fill="#526275"
      />,
    ],
  },
  twitterLink: {
    viewBox: '0 0 90 90',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z M 59 68 H 66 L 31 22 H 24 L 59 68 Z"
        fill="#526275"
      />,
    ],
  },
  imdbLink: {
    viewBox: '0 0 25 24',
    paths: [
      <path
        d="M13.8857 9.55734C14.1 9.55734 14.2286 9.55734 14.3143 9.6002C14.4 9.64306 14.4429 9.72877 14.4429 9.81449C14.4857 9.9002 14.4857 10.1145 14.4857 10.4573V13.3288C14.4857 13.8002 14.4429 14.1002 14.4 14.2288C14.3572 14.3573 14.1857 14.4002 13.8857 14.4002V9.55734Z"
        fill="#526275"
      />,
      <path
        d="M19.0716 11.1857C18.9859 11.1857 18.9002 11.2286 18.8573 11.3143C18.8145 11.4 18.8145 11.6143 18.8145 11.9572V13.8857C18.8145 14.2286 18.8145 14.4429 18.8573 14.5286C18.9002 14.6143 18.943 14.6572 19.0716 14.6572C19.2002 14.6572 19.3287 14.6143 19.3716 14.5286C19.4145 14.4 19.4145 14.1857 19.4145 13.8429V11.9143C19.4145 11.6143 19.4145 11.4 19.3716 11.3143C19.3287 11.2286 19.2002 11.1857 19.0716 11.1857Z"
        fill="#526275"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.4 0 0 5.35714 0 12C0 18.6429 5.35714 24 12 24C18.6 24 24 18.6429 24 12C24 5.35714 18.6 0 12 0ZM4.8 15.6429H2.91429V8.27143H4.8V15.6429ZM11.3571 15.6429H9.68571V10.6714L9 15.6429H7.8L7.11429 10.8V15.6429H5.44286V8.27143H7.92857C7.96036 8.62106 8.01571 8.99426 8.07716 9.40851C8.09857 9.55282 8.12071 9.70214 8.14286 9.85714L8.44286 11.7L8.87143 8.27143H11.3571V15.6429ZM16.2857 13.4571C16.2857 14.1 16.2429 14.5714 16.2 14.7857C16.1143 15 16.0286 15.1714 15.8571 15.3C15.7286 15.4286 15.5143 15.5143 15.3 15.5571C15.0857 15.6 14.7429 15.6429 14.2714 15.6429H12V8.27143H13.4143C14.3143 8.27143 14.8714 8.31429 15.1714 8.4C15.4714 8.48571 15.7286 8.61429 15.9 8.82857C16.0714 9 16.1571 9.21429 16.2 9.47143C16.2429 9.72857 16.2857 10.2 16.2857 10.8857V13.4571ZM21.2143 14.9143C21.1286 15.1286 21 15.3 20.7857 15.4714C20.5714 15.6429 20.3143 15.7286 20.0143 15.7286C19.8 15.7286 19.5 15.6857 19.3286 15.6C19.1571 15.5143 18.9857 15.3429 18.8143 15.1714L18.6857 15.6429H16.9714V8.22857H18.8143V10.6286C18.9857 10.4571 19.1571 10.3286 19.3286 10.2429C19.5 10.1571 19.8 10.1143 20.0143 10.1143C20.2714 10.1143 20.4857 10.1571 20.6571 10.2429C20.8286 10.3286 21 10.4571 21.0857 10.5857C21.1036 10.6215 21.1215 10.6554 21.1386 10.6878C21.2035 10.8108 21.2571 10.9125 21.2571 11.0143C21.3 11.1429 21.3 11.4429 21.3 11.8714V13.9286C21.3 14.3571 21.2571 14.7 21.2143 14.9143Z"
        fill="#526275"
      />,
    ],
  },
  youtubeLink: {
    paths: [
      <path
        d="M10.2559 9.86251L14.6996 12.15L10.2559 14.475V9.86251Z"
        fill="#526275"
      />,
      <path
        d="M12 24C5.38125 24 0 18.6187 0 12C0 5.38125 5.38125 0 12 0C18.6187 0 24 5.38125 24 12C24 18.6187 18.6187 24 12 24ZM19.5 11.4375C19.5 10.2188 19.35 9.01875 19.35 9.01875C19.35 9.01875 19.2 7.9875 18.75 7.5375C18.1875 6.9375 17.5312 6.9375 17.25 6.9C15.15 6.75 12 6.75 12 6.75C12 6.75 8.1 6.7875 6.9 6.9C6.5625 6.9375 5.8125 6.91875 5.25 7.51875C4.8 7.96875 4.65 9 4.65 9C4.65 9 4.5 10.2188 4.5 11.4375V12.5625C4.5 13.7812 4.65 14.9813 4.65 14.9813C4.65 14.9813 4.8 16.0125 5.25 16.4625C5.8125 17.0625 6.46875 17.0625 6.75 17.1C8.85 17.25 12 17.25 12 17.25C12 17.25 15.15 17.25 17.25 17.1C17.55 17.0625 18.1875 17.0625 18.75 16.4625C19.2 16.0125 19.35 14.9813 19.35 14.9813C19.35 14.9813 19.5 13.7812 19.5 12.5625V11.4375Z"
        fill="#526275"
      />,
    ],
  },
  profile: {
    paths: [
      <path
        fill="#808B99"
        fillRule="evenodd"
        d="M 4.375 15.375 C 5.335938 14.414062 6.640625 13.875 8 13.875 L 16 13.875 C 17.359375 13.875 18.664062 14.414062 19.625 15.375 C 20.585938 16.335938 21.125 17.640625 21.125 19 L 21.125 21 C 21.125 21.621094 20.621094 22.125 20 22.125 C 19.378906 22.125 18.875 21.621094 18.875 21 L 18.875 19 C 18.875 18.238281 18.570312 17.507812 18.03125 16.96875 C 17.492188 16.429688 16.761719 16.125 16 16.125 L 8 16.125 C 7.238281 16.125 6.507812 16.429688 5.96875 16.96875 C 5.425781 17.507812 5.125 18.238281 5.125 19 L 5.125 21 C 5.125 21.621094 4.621094 22.125 4 22.125 C 3.378906 22.125 2.875 21.621094 2.875 21 L 2.875 19 C 2.875 17.640625 3.414062 16.335938 4.375 15.375 Z M 4.375 15.375 "
      />,
      <path
        fill="#808B99"
        fillRule="evenodd"
        d="M 12 4.125 C 10.414062 4.125 9.125 5.414062 9.125 7 C 9.125 8.585938 10.414062 9.875 12 9.875 C 13.589844 9.875 14.875 8.585938 14.875 7 C 14.875 5.414062 13.589844 4.125 12 4.125 Z M 6.875 7 C 6.875 4.167969 9.167969 1.875 12 1.875 C 14.832031 1.875 17.125 4.167969 17.125 7 C 17.125 9.832031 14.832031 12.125 12 12.125 C 9.167969 12.125 6.875 9.832031 6.875 7 Z M 6.875 7 "
      />,
    ],
  },
  settings: {
    paths: [
      <path
        fill="#808B99"
        fillRule="nonzero"
        d="M 20.023438 13.027344 C 20.066406 12.691406 20.097656 12.355469 20.097656 12 C 20.097656 11.644531 20.066406 11.308594 20.023438 10.972656 L 22.300781 9.238281 C 22.503906 9.082031 22.558594 8.796875 22.429688 8.566406 L 20.269531 4.933594 C 20.171875 4.765625 19.992188 4.671875 19.796875 4.671875 C 19.730469 4.671875 19.667969 4.679688 19.613281 4.703125 L 16.925781 5.753906 C 16.363281 5.332031 15.757812 4.984375 15.101562 4.722656 L 14.691406 1.941406 C 14.65625 1.6875 14.429688 1.5 14.160156 1.5 L 9.84375 1.5 C 9.574219 1.5 9.347656 1.6875 9.316406 1.941406 L 8.90625 4.722656 C 8.246094 4.984375 7.640625 5.34375 7.078125 5.753906 L 4.390625 4.703125 C 4.328125 4.679688 4.261719 4.671875 4.199219 4.671875 C 4.015625 4.671875 3.832031 4.765625 3.734375 4.933594 L 1.574219 8.566406 C 1.433594 8.796875 1.5 9.082031 1.703125 9.238281 L 3.980469 10.972656 C 3.9375 11.308594 3.90625 11.652344 3.90625 12 C 3.90625 12.347656 3.9375 12.691406 3.980469 13.027344 L 1.703125 14.761719 C 1.5 14.917969 1.445312 15.203125 1.574219 15.433594 L 3.734375 19.066406 C 3.832031 19.234375 4.015625 19.328125 4.207031 19.328125 C 4.273438 19.328125 4.339844 19.320312 4.390625 19.296875 L 7.078125 18.246094 C 7.640625 18.667969 8.246094 19.015625 8.90625 19.277344 L 9.316406 22.058594 C 9.347656 22.3125 9.574219 22.5 9.84375 22.5 L 14.160156 22.5 C 14.429688 22.5 14.65625 22.3125 14.691406 22.058594 L 15.101562 19.277344 C 15.757812 19.015625 16.363281 18.65625 16.925781 18.246094 L 19.613281 19.296875 C 19.675781 19.320312 19.742188 19.328125 19.808594 19.328125 C 19.992188 19.328125 20.171875 19.234375 20.269531 19.066406 L 22.429688 15.433594 C 22.558594 15.203125 22.503906 14.917969 22.300781 14.761719 Z M 17.886719 11.234375 C 17.929688 11.558594 17.9375 11.78125 17.9375 12 C 17.9375 12.21875 17.917969 12.453125 17.886719 12.765625 L 17.734375 13.953125 L 18.695312 14.6875 L 19.859375 15.570312 L 19.105469 16.839844 L 17.734375 16.304688 L 16.613281 15.863281 L 15.640625 16.578125 C 15.175781 16.914062 14.734375 17.164062 14.289062 17.34375 L 13.148438 17.796875 L 12.972656 18.984375 L 12.757812 20.398438 L 11.246094 20.398438 L 11.042969 18.984375 L 10.867188 17.796875 L 9.726562 17.34375 C 9.261719 17.15625 8.828125 16.914062 8.398438 16.597656 L 7.414062 15.863281 L 6.269531 16.316406 L 4.898438 16.851562 L 4.144531 15.582031 L 5.308594 14.699219 L 6.269531 13.964844 L 6.121094 12.777344 C 6.085938 12.453125 6.066406 12.210938 6.066406 12 C 6.066406 11.789062 6.085938 11.546875 6.121094 11.234375 L 6.269531 10.046875 L 5.308594 9.3125 L 4.144531 8.429688 L 4.898438 7.160156 L 6.269531 7.695312 L 7.394531 8.136719 L 8.363281 7.421875 C 8.828125 7.085938 9.269531 6.835938 9.714844 6.65625 L 10.859375 6.203125 L 11.03125 5.015625 L 11.246094 3.601562 L 12.746094 3.601562 L 12.953125 5.015625 L 13.125 6.203125 L 14.269531 6.65625 C 14.734375 6.84375 15.164062 7.085938 15.597656 7.402344 L 16.578125 8.136719 L 17.722656 7.683594 L 19.09375 7.148438 L 19.851562 8.417969 L 18.695312 9.3125 L 17.734375 10.046875 Z M 12.003906 7.800781 C 9.617188 7.800781 7.683594 9.679688 7.683594 12 C 7.683594 14.320312 9.617188 16.199219 12.003906 16.199219 C 14.386719 16.199219 16.320312 14.320312 16.320312 12 C 16.320312 9.679688 14.386719 7.800781 12.003906 7.800781 Z M 12.003906 14.101562 C 10.816406 14.101562 9.84375 13.15625 9.84375 12 C 9.84375 10.84375 10.816406 9.898438 12.003906 9.898438 C 13.191406 9.898438 14.160156 10.84375 14.160156 12 C 14.160156 13.15625 13.191406 14.101562 12.003906 14.101562 Z M 12.003906 14.101562 "
      />,
    ],
  },
  settingsDropdown: {
    fill: 'none',
    viewBox: '0 0 12 8',
    paths: [
      <path
        d="M11.2946 0.999537C10.9053 0.610265 10.2743 0.609921 9.88462 0.998769L6 4.87492L2.11538 0.998768C1.72569 0.609921 1.09466 0.610265 0.705384 0.999537C0.315811 1.38911 0.315811 2.02073 0.705385 2.41031L6 7.70492L11.2946 2.41031C11.6842 2.02073 11.6842 1.38911 11.2946 0.999537Z"
        fill="#808B99"
      />,
    ],
  },
  organization: {
    paths: [
      <path
        fill="#808B99"
        fillRule="evenodd"
        d="M 1.875 3 C 1.875 2.378906 2.378906 1.875 3 1.875 L 10 1.875 C 10.621094 1.875 11.125 2.378906 11.125 3 L 11.125 10 C 11.125 10.621094 10.621094 11.125 10 11.125 L 3 11.125 C 2.378906 11.125 1.875 10.621094 1.875 10 Z M 4.125 4.125 L 4.125 8.875 L 8.875 8.875 L 8.875 4.125 Z M 4.125 4.125 "
      />,
      <path
        fill="#808B99"
        fillRule="evenodd"
        d="M 12.875 3 C 12.875 2.378906 13.378906 1.875 14 1.875 L 21 1.875 C 21.621094 1.875 22.125 2.378906 22.125 3 L 22.125 10 C 22.125 10.621094 21.621094 11.125 21 11.125 L 14 11.125 C 13.378906 11.125 12.875 10.621094 12.875 10 Z M 15.125 4.125 L 15.125 8.875 L 19.875 8.875 L 19.875 4.125 Z M 15.125 4.125 "
      />,
      <path
        fill="#808B99"
        fillRule="evenodd"
        d="M 12.875 14 C 12.875 13.378906 13.378906 12.875 14 12.875 L 21 12.875 C 21.621094 12.875 22.125 13.378906 22.125 14 L 22.125 21 C 22.125 21.621094 21.621094 22.125 21 22.125 L 14 22.125 C 13.378906 22.125 12.875 21.621094 12.875 21 Z M 15.125 15.125 L 15.125 19.875 L 19.875 19.875 L 19.875 15.125 Z M 15.125 15.125 "
      />,
      <path
        fill="#808B99"
        fillRule="evenodd"
        d="M 1.875 14 C 1.875 13.378906 2.378906 12.875 3 12.875 L 10 12.875 C 10.621094 12.875 11.125 13.378906 11.125 14 L 11.125 21 C 11.125 21.621094 10.621094 22.125 10 22.125 L 3 22.125 C 2.378906 22.125 1.875 21.621094 1.875 21 Z M 4.125 15.125 L 4.125 19.875 L 8.875 19.875 L 8.875 15.125 Z M 4.125 15.125 "
      />,
    ],
  },
  signOut: {
    paths: [
      <path
        fill="#808B99"
        fillRule="evenodd"
        d="M 3.789062 2.789062 C 4.375 2.203125 5.171875 1.875 6 1.875 L 10 1.875 C 10.621094 1.875 11.125 2.378906 11.125 3 C 11.125 3.621094 10.621094 4.125 10 4.125 L 6 4.125 C 5.769531 4.125 5.546875 4.21875 5.382812 4.382812 C 5.21875 4.546875 5.125 4.769531 5.125 5 L 5.125 19 C 5.125 19.480469 5.519531 19.875 6 19.875 L 10 19.875 C 10.621094 19.875 11.125 20.378906 11.125 21 C 11.125 21.621094 10.621094 22.125 10 22.125 L 6 22.125 C 4.277344 22.125 2.875 20.722656 2.875 19 L 2.875 5 C 2.875 4.171875 3.203125 3.375 3.789062 2.789062 Z M 15.203125 6.203125 C 15.644531 5.765625 16.355469 5.765625 16.796875 6.203125 L 21.796875 11.203125 C 22.234375 11.644531 22.234375 12.355469 21.796875 12.796875 L 16.796875 17.796875 C 16.355469 18.234375 15.644531 18.234375 15.203125 17.796875 C 14.765625 17.355469 14.765625 16.644531 15.203125 16.203125 L 18.285156 13.125 L 9 13.125 C 8.378906 13.125 7.875 12.621094 7.875 12 C 7.875 11.378906 8.378906 10.875 9 10.875 L 18.285156 10.875 L 15.203125 7.796875 C 14.765625 7.355469 14.765625 6.644531 15.203125 6.203125 Z M 15.203125 6.203125 "
      />,
    ],
  },
  selectArrow: {
    paths: [
      <path
        fill="#808B99"
        fillRule="nonzero"
        d="M 4.242188 1.5 C 1.570312 1.5 0.230469 4.730469 2.121094 6.621094 L 9.878906 14.378906 C 11.050781 15.550781 12.949219 15.550781 14.121094 14.378906 L 21.878906 6.621094 C 23.769531 4.730469 22.429688 1.5 19.757812 1.5 Z M 4.242188 1.5"
      />,
    ],
  },
  trash: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29289 2.29295C7.48043 2.10542 7.73478 2.00006 8 2.00006H12C12.2652 2.00006 12.5196 2.10542 12.7071 2.29295C12.8946 2.48049 13 2.73484 13 3.00006V4H7V3.00006C7 2.73484 7.10536 2.48049 7.29289 2.29295ZM5 4V3.00006C5 2.20441 5.31607 1.44135 5.87868 0.878741C6.44129 0.316132 7.20435 6.10352e-05 8 6.10352e-05H12C12.7956 6.10352e-05 13.5587 0.316132 14.1213 0.878741C14.6839 1.44135 15 2.20441 15 3.00006V4H19C19.5523 4 20 4.44772 20 5C20 5.55228 19.5523 6 19 6H18V19.0001C18 19.7957 17.6839 20.5588 17.1213 21.1214C16.5587 21.684 15.7957 22.0001 15 22.0001H5C4.20435 22.0001 3.44129 21.684 2.87868 21.1214C2.31607 20.5588 2 19.7957 2 19.0001V6H1C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4H3H5ZM6 6.00006H14H16V19.0001C16 19.2653 15.8946 19.5196 15.7071 19.7072C15.5196 19.8947 15.2652 20.0001 15 20.0001H5C4.73478 20.0001 4.48043 19.8947 4.29289 19.7072C4.10536 19.5196 4 19.2653 4 19.0001V6.00006H6ZM8 9.00006C8.55229 9.00006 9 9.44778 9 10.0001V16.0001C9 16.5523 8.55229 17.0001 8 17.0001C7.44772 17.0001 7 16.5523 7 16.0001V10.0001C7 9.44778 7.44772 9.00006 8 9.00006ZM13 16.0001V10.0001C13 9.44778 12.5523 9.00006 12 9.00006C11.4477 9.00006 11 9.44778 11 10.0001V16.0001C11 16.5523 11.4477 17.0001 12 17.0001C12.5523 17.0001 13 16.5523 13 16.0001Z"
        fill="black"
      />,
    ],
  },
  play: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.34694 8.59838C9.21088 8.51881 9.04082 8.61827 9.04082 8.77741L9.04082 15.2226C9.04082 15.3817 9.21088 15.4812 9.34694 15.4016L14.8571 12.179C14.9932 12.0995 14.9932 11.9005 14.8571 11.821L9.34694 8.59838ZM15.8776 13.9694L10.3673 17.1919C8.87075 18.0672 7 16.9731 7 15.2226L7 8.77741C7 7.02687 8.87075 5.93278 10.3673 6.80805L15.8776 10.0306C17.3741 10.9059 17.3741 13.0941 15.8776 13.9694Z"
        fill="white"
      />,
    ],
  },
  stop: {
    viewBox: '0 0 16 16',
    fill: 'none',
    paths: [
      <path d="M0.5 0H16.5V16H0.5V0Z" />,
      <rect
        x="3.25"
        y="2.75"
        width="10.5"
        height="10.5"
        rx="1.25"
        stroke="#808B99"
        strokeWidth="1.5"
      />,
    ],
  },
  run: {
    viewBox: '0 0 16 16',
    fill: 'none',
    paths: [
      <g clipPath="url(#clip0)">
        <path d="M0.5 0H16.5V16H0.5V0Z" fill="white" fillOpacity="0" />
        <path
          d="M12.125 6.91747C12.9583 7.39859 12.9583 8.60141 12.125 9.08253L6.125 12.5466C5.29167 13.0278 4.25 12.4264 4.25 11.4641L4.25 4.5359C4.25 3.57365 5.29167 2.97224 6.125 3.45337L12.125 6.91747Z"
          stroke="#808B99"
          strokeWidth="1.5"
          fillOpacity="0"
        />
      </g>,
    ],
  },
  firstPage: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.65233 18C10.2046 18 10.6523 17.5523 10.6523 17L10.6523 6.99999C10.6523 6.4477 10.2046 5.99999 9.65233 6C9.10005 6.00001 8.65234 6.44773 8.65234 7.00001L8.65234 17C8.65234 17.5523 9.10005 18 9.65233 18Z"
        fill="#051528"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3653 17.6928C19.7479 17.2945 19.7352 16.6615 19.3369 16.2789L14.8829 12L19.3369 7.72115C19.7352 7.33853 19.7479 6.70549 19.3653 6.30722C18.9827 5.90894 18.3496 5.89624 17.9514 6.27886L12.7467 11.2789C12.5504 11.4674 12.4395 11.7278 12.4395 12C12.4395 12.2722 12.5504 12.5326 12.7467 12.7211L17.9514 17.7211C18.3496 18.1038 18.9827 18.0911 19.3653 17.6928Z"
        fill="#051528"
      />,
    ],
  },
  lastPage: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3486 18C14.7964 18 14.3486 17.5523 14.3486 17L14.3486 6.99999C14.3486 6.4477 14.7964 5.99999 15.3486 6C15.9009 6.00001 16.3486 6.44773 16.3486 7.00001L16.3486 17C16.3486 17.5523 15.9009 18 15.3486 18Z"
        fill="#051528"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63569 17.6928C5.25307 17.2945 5.26577 16.6615 5.66405 16.2789L10.1181 12L5.66405 7.72115C5.26577 7.33853 5.25307 6.70549 5.63569 6.30722C6.0183 5.90894 6.65134 5.89624 7.04962 6.27886L12.2543 11.2789C12.4506 11.4674 12.5615 11.7278 12.5615 12C12.5615 12.2722 12.4506 12.5326 12.2543 12.7211L7.04962 17.7211C6.65134 18.1038 6.0183 18.0911 5.63569 17.6928Z"
        fill="#051528"
      />,
    ],
  },
  previousPage: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5538 17.6928C15.9364 17.2945 15.9237 16.6615 15.5254 16.2789L11.0714 12L15.5254 7.72115C15.9237 7.33853 15.9364 6.70549 15.5538 6.30722C15.1711 5.90894 14.5381 5.89624 14.1398 6.27886L8.93515 11.2789C8.73887 11.4674 8.62793 11.7278 8.62793 12C8.62793 12.2722 8.73887 12.5326 8.93515 12.7211L14.1398 17.7211C14.5381 18.1038 15.1711 18.0911 15.5538 17.6928Z"
        fill="#051528"
      />,
    ],
  },
  nextPage: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4482 17.6928C9.06559 17.2945 9.07828 16.6615 9.47656 16.2789L13.9306 12L9.47656 7.72115C9.07828 7.33853 9.06559 6.70549 9.4482 6.30722C9.83082 5.90894 10.4639 5.89624 10.8621 6.27886L16.0668 11.2789C16.2631 11.4674 16.374 11.7278 16.374 12C16.374 12.2722 16.2631 12.5326 16.0668 12.7211L10.8621 17.7211C10.4639 18.1038 9.83082 18.0911 9.4482 17.6928Z"
        fill="#051528"
      />,
    ],
  },
  award: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0008 8.49023C18.0008 10.4643 17.1035 12.2288 15.6946 13.3982L17.9704 22.0014C18.1682 22.7492 17.3625 23.3707 16.6631 23.0098L11.6771 20.4369C11.5406 20.3664 11.3767 20.3684 11.2419 20.4421L6.60769 22.9762C5.92019 23.3522 5.1013 22.756 5.27423 22.0054L7.30753 13.18C6.04301 12.015 5.25081 10.3451 5.25081 8.49023C5.25081 4.96942 8.105 2.11523 11.6258 2.11523C15.1466 2.11523 18.0008 4.96942 18.0008 8.49023ZM11.6258 13.7402C14.5253 13.7402 16.8758 11.3897 16.8758 8.49023C16.8758 5.59074 14.5253 3.24023 11.6258 3.24023C8.72632 3.24023 6.37581 5.59074 6.37581 8.49023C6.37581 11.3897 8.72632 13.7402 11.6258 13.7402ZM11.6258 14.8652C12.7442 14.8652 13.7953 14.5773 14.709 14.0714L16.7505 21.789L12.193 19.4372C11.7245 19.1954 11.165 19.2019 10.7021 19.455L6.48498 21.7611L8.29053 13.9242C9.26082 14.521 10.4031 14.8652 11.6258 14.8652Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00081 8.49023C5.00081 4.83135 7.96693 1.86523 11.6258 1.86523C15.2847 1.86523 18.2508 4.83135 18.2508 8.49023C18.2508 10.4841 17.3697 12.2723 15.9766 13.4865L18.2121 21.9375C18.4694 22.9102 17.4262 23.6849 16.5485 23.232L11.5625 20.6591C11.4997 20.6267 11.4237 20.6276 11.3618 20.6614L6.72764 23.1956C5.86455 23.6676 4.80578 22.9251 5.03061 21.9492L7.03171 13.2636C5.78007 12.0587 5.00081 10.3653 5.00081 8.49023ZM11.6258 2.36523C8.24307 2.36523 5.50081 5.10749 5.50081 8.49023C5.50081 10.2724 6.26162 11.8765 7.47692 12.9961L7.58376 13.0945L5.51785 22.0615C5.39683 22.5868 5.97584 23.0368 6.48775 22.7569L11.1219 20.2227C11.3296 20.1092 11.5814 20.1062 11.7918 20.2148L16.7778 22.7877C17.2989 23.0566 17.8671 22.5883 17.7287 22.0654L15.4121 13.3078L15.5349 13.2058C16.8891 12.0819 17.7508 10.3868 17.7508 8.49023C17.7508 5.10749 15.0086 2.36523 11.6258 2.36523ZM11.6258 3.49023C8.86439 3.49023 6.62581 5.72881 6.62581 8.49023C6.62581 11.2517 8.86439 13.4902 11.6258 13.4902C14.3872 13.4902 16.6258 11.2517 16.6258 8.49023C16.6258 5.72881 14.3872 3.49023 11.6258 3.49023ZM6.12581 8.49023C6.12581 5.45267 8.58825 2.99023 11.6258 2.99023C14.6634 2.99023 17.1258 5.45267 17.1258 8.49023C17.1258 11.5278 14.6634 13.9902 11.6258 13.9902C8.58825 13.9902 6.12581 11.5278 6.12581 8.49023ZM8.12505 13.5289L8.42151 13.7113C9.35353 14.2845 10.4507 14.6152 11.6258 14.6152C12.7007 14.6152 13.7103 14.3385 14.5879 13.8527L14.8686 13.6973L17.1362 22.2693L12.0784 19.6593C11.6836 19.4556 11.2121 19.4611 10.8221 19.6744L6.11634 22.2476L8.12505 13.5289ZM8.45814 14.3102L6.85362 21.2746L10.5822 19.2357C11.118 18.9427 11.7654 18.9352 12.3077 19.215L16.3648 21.3086L14.5473 14.4379C13.6658 14.8717 12.674 15.1152 11.6258 15.1152C10.4788 15.1152 9.39935 14.8236 8.45814 14.3102Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.05 8.49018C15.05 10.3809 13.5173 11.9136 11.6266 11.9136C9.73596 11.9136 8.20325 10.3809 8.20325 8.49018C8.20325 6.5995 9.73596 5.06679 11.6266 5.06679C13.5173 5.06679 15.05 6.5995 15.05 8.49018ZM14.1164 8.49018C14.1164 9.86523 13.0017 10.9799 11.6266 10.9799C10.2516 10.9799 9.13691 9.86523 9.13691 8.49018C9.13691 7.11514 10.2516 6.00044 11.6266 6.00044C13.0017 6.00044 14.1164 7.11514 14.1164 8.49018Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.95325 8.49018C7.95325 6.46143 9.59789 4.81679 11.6266 4.81679C13.6554 4.81679 15.3 6.46143 15.3 8.49018C15.3 10.5189 13.6554 12.1636 11.6266 12.1636C9.59789 12.1636 7.95325 10.5189 7.95325 8.49018ZM11.6266 5.31679C9.87403 5.31679 8.45325 6.73757 8.45325 8.49018C8.45325 10.2428 9.87403 11.6636 11.6266 11.6636C13.3793 11.6636 14.8 10.2428 14.8 8.49018C14.8 6.73757 13.3793 5.31679 11.6266 5.31679ZM8.88691 8.49018C8.88691 6.97707 10.1135 5.75044 11.6266 5.75044C13.1398 5.75044 14.3664 6.97707 14.3664 8.49018C14.3664 10.0033 13.1398 11.2299 11.6266 11.2299C10.1135 11.2299 8.88691 10.0033 8.88691 8.49018ZM11.6266 6.25044C10.3897 6.25044 9.38691 7.25321 9.38691 8.49018C9.38691 9.72716 10.3897 10.7299 11.6266 10.7299C12.8636 10.7299 13.8664 9.72716 13.8664 8.49018C13.8664 7.25321 12.8636 6.25044 11.6266 6.25044Z"
        fill="#808B99"
      />,
    ],
  },
  recording: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0.25C11.0054 0.25 10.0516 0.645088 9.34835 1.34835C8.64509 2.05161 8.25 3.00544 8.25 4V12C8.25 12.9946 8.64509 13.9484 9.34835 14.6517C10.0516 15.3549 11.0054 15.75 12 15.75C12.9946 15.75 13.9484 15.3549 14.6517 14.6517C15.3549 13.9484 15.75 12.9946 15.75 12V4C15.75 3.00544 15.3549 2.05161 14.6517 1.34835C13.9484 0.645088 12.9946 0.25 12 0.25ZM10.409 2.40901C10.831 1.98705 11.4033 1.75 12 1.75C12.5967 1.75 13.169 1.98705 13.591 2.40901C14.0129 2.83097 14.25 3.40326 14.25 4V12C14.25 12.5967 14.0129 13.169 13.591 13.591C13.169 14.0129 12.5967 14.25 12 14.25C11.4033 14.25 10.831 14.0129 10.409 13.591C9.98705 13.169 9.75 12.5967 9.75 12V4C9.75 3.40326 9.98705 2.83097 10.409 2.40901ZM5.75 10C5.75 9.58579 5.41421 9.25 5 9.25C4.58579 9.25 4.25 9.58579 4.25 10V12C4.25 14.0554 5.06652 16.0267 6.51992 17.4801C7.79547 18.7556 9.46988 19.5406 11.25 19.7136V22.25H8C7.58579 22.25 7.25 22.5858 7.25 23C7.25 23.4142 7.58579 23.75 8 23.75H12H16C16.4142 23.75 16.75 23.4142 16.75 23C16.75 22.5858 16.4142 22.25 16 22.25H12.75V19.7136C14.5301 19.5406 16.2045 18.7556 17.4801 17.4801C18.9335 16.0267 19.75 14.0554 19.75 12V10C19.75 9.58579 19.4142 9.25 19 9.25C18.5858 9.25 18.25 9.58579 18.25 10V12C18.25 13.6576 17.5915 15.2473 16.4194 16.4194C15.2473 17.5915 13.6576 18.25 12 18.25C10.3424 18.25 8.75268 17.5915 7.58058 16.4194C6.40848 15.2473 5.75 13.6576 5.75 12V10Z"
        fill="#808B99"
      />,
    ],
  },
  location: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.884 8.85618C11.8816 8.85618 11.069 9.66881 11.069 10.6712C11.069 11.6737 11.8816 12.4863 12.884 12.4863C13.8864 12.4863 14.699 11.6737 14.699 10.6712C14.699 9.66881 13.8864 8.85618 12.884 8.85618ZM9.25391 10.6712C9.25391 8.66638 10.8792 7.04114 12.884 7.04114C14.8888 7.04114 16.5141 8.66638 16.5141 10.6712C16.5141 12.6761 14.8888 14.3013 12.884 14.3013C10.8792 14.3013 9.25391 12.6761 9.25391 10.6712Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.10906 4.89581C8.6408 3.36406 10.7183 2.50354 12.8845 2.50354C15.0507 2.50354 17.1282 3.36406 18.6599 4.89581C20.1917 6.42755 21.0522 8.50503 21.0522 10.6712C21.0522 12.2926 20.3298 14.0617 19.0682 15.9128C17.7979 17.7768 15.9245 19.8064 13.4866 21.9683C13.1403 22.2754 12.6184 22.2726 12.2753 21.9619C9.84256 19.7587 7.97138 17.7312 6.70231 15.881C5.44135 14.0426 4.7168 12.2952 4.7168 10.6712C4.7168 8.50503 5.57732 6.42755 7.10906 4.89581ZM12.8845 4.31859C11.1997 4.31859 9.58385 4.98788 8.39249 6.17924C7.20114 7.37059 6.53184 8.98642 6.53184 10.6712C6.53184 11.7699 7.03245 13.1534 8.19911 14.8544C9.25739 16.3973 10.8166 18.1331 12.8904 20.0629C14.9569 18.1731 16.5123 16.4402 17.5684 14.8906C18.7344 13.1797 19.2372 11.7724 19.2372 10.6712C19.2372 8.98642 18.5679 7.37059 17.3765 6.17924C16.1852 4.98788 14.5693 4.31859 12.8845 4.31859Z"
        fill="#808B99"
      />,
    ],
  },
  websiteLink: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6532 4.87531C8.44212 4.87531 5.02838 8.28904 5.02838 12.5001C5.02838 16.7112 8.44212 20.1249 12.6532 20.1249C16.8642 20.1249 20.278 16.7112 20.278 12.5001C20.278 8.28904 16.8642 4.87531 12.6532 4.87531ZM3.33398 12.5001C3.33398 7.35325 7.50633 3.18091 12.6532 3.18091C17.8 3.18091 21.9724 7.35325 21.9724 12.5001C21.9724 17.6469 17.8 21.8193 12.6532 21.8193C7.50633 21.8193 3.33398 17.6469 3.33398 12.5001Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33398 12.5001C3.33398 12.0322 3.71329 11.6528 4.18118 11.6528H21.1252C21.5931 11.6528 21.9724 12.0322 21.9724 12.5001C21.9724 12.968 21.5931 13.3472 21.1252 13.3472H4.18118C3.71329 13.3472 3.33398 12.968 3.33398 12.5001Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1118 12.5001C10.1698 15.1051 11.0657 17.6131 12.6532 19.6582C14.2406 17.6131 15.1365 15.1051 15.1946 12.5001C15.1365 9.89509 14.2406 7.38712 12.6532 5.34194C11.0657 7.38712 10.1698 9.89509 10.1118 12.5001ZM12.6532 4.02811L12.0276 3.45674C9.77006 5.9283 8.48708 9.13575 8.41736 12.4824C8.41712 12.4942 8.41712 12.506 8.41736 12.5177C8.48708 15.8644 9.77006 19.0719 12.0276 21.5435C12.1882 21.7192 12.4152 21.8193 12.6532 21.8193C12.8912 21.8193 13.1182 21.7192 13.2787 21.5435C15.5363 19.0719 16.8193 15.8644 16.889 12.5177C16.8892 12.506 16.8892 12.4942 16.889 12.4824C16.8193 9.13575 15.5363 5.9283 13.2787 3.45674L12.6532 4.02811Z"
        fill="#808B99"
      />,
    ],
  },
  audibleLink: {
    paths: [
      <path
        d="M12.4204 5.30005C8.61015 5.30005 5.04999 7.47685 3.35319 10.8426C3.29844 10.9503 3.28616 11.0746 3.3188 11.1909C3.35143 11.3072 3.42658 11.407 3.52935 11.4704C3.74487 11.6 4.02231 11.5439 4.16871 11.3432C6.00231 8.82325 8.39799 7.70005 11.9404 7.70005C17.0462 7.70005 18.9676 11.6471 19.0487 11.8156C19.0873 11.8977 19.1486 11.9671 19.2253 12.0155C19.302 12.064 19.3909 12.0896 19.4817 12.0892C19.5561 12.0894 19.6294 12.0715 19.6953 12.0368L21.0825 11.3452C21.1977 11.2871 21.2855 11.1858 21.3249 11.062C21.3446 11.001 21.3519 10.9366 21.3461 10.8728C21.3403 10.8089 21.3217 10.7469 21.2913 10.6904C19.5206 7.36645 16.1212 5.30005 12.4204 5.30005ZM12.4204 8.66005C9.84759 8.66005 7.77399 9.86581 6.25527 12.2432C6.19277 12.3413 6.16819 12.4588 6.18613 12.5737C6.20407 12.6885 6.2633 12.7929 6.35271 12.8672C6.44155 12.9425 6.55483 12.9827 6.67125 12.9804C6.78766 12.978 6.89919 12.9331 6.98487 12.8543C8.30487 11.6471 9.76743 11.06 11.4604 11.06C13.6074 11.06 15.25 11.8362 16.2153 13.3045C16.2798 13.4025 16.3778 13.4737 16.4909 13.5048C16.604 13.5359 16.7246 13.5247 16.8302 13.4735L18.323 12.7247C18.3827 12.6947 18.4356 12.6526 18.4782 12.6011C18.5208 12.5495 18.5522 12.4896 18.5704 12.4253C18.5885 12.3609 18.5931 12.2935 18.5837 12.2272C18.5743 12.161 18.5512 12.0975 18.5159 12.0407C17.1868 9.92389 14.9087 8.66005 12.4204 8.66005ZM1.35399 11.54C1.27271 11.5452 1.19409 11.571 1.12551 11.6149C1.05646 11.6576 0.999509 11.7172 0.960093 11.7881C0.920678 11.859 0.900123 11.9389 0.900393 12.02V13.46C0.900393 13.6458 1.00743 13.8143 1.17399 13.893L12.2121 19.173C12.2771 19.2042 12.3483 19.2204 12.4204 19.2204C12.4925 19.2204 12.5637 19.2042 12.6287 19.173L23.6687 13.893C23.7502 13.8538 23.8189 13.7923 23.867 13.7157C23.915 13.6391 23.9405 13.5505 23.9404 13.46V12.02C23.9407 11.9389 23.9201 11.859 23.8807 11.7881C23.8413 11.7172 23.7843 11.6576 23.7153 11.6149C23.6467 11.5714 23.5683 11.546 23.4873 11.5412C23.4062 11.5363 23.3253 11.5521 23.2521 11.5871L12.4204 16.7672L1.58679 11.5871C1.51436 11.5522 1.43431 11.536 1.35399 11.54ZM12.4204 12.02C11.0702 12.02 9.81207 12.6536 9.13911 13.676C9.07772 13.7684 9.05019 13.8791 9.06121 13.9895C9.07222 14.0998 9.12111 14.203 9.19954 14.2813C9.27798 14.3597 9.38114 14.4085 9.49149 14.4195C9.60184 14.4304 9.71257 14.4028 9.80487 14.3413C10.1966 14.0821 10.7855 13.94 11.4604 13.94C12.2255 13.94 12.9455 14.2362 13.4894 14.7762C13.581 14.8684 13.703 14.9154 13.8287 14.9154C13.8998 14.9154 13.9746 14.9 14.0423 14.8664L15.2927 14.24C15.3564 14.2087 15.4122 14.1636 15.4562 14.1079C15.5002 14.0523 15.5312 13.9875 15.5471 13.9184C15.5629 13.8492 15.5631 13.7774 15.5476 13.7082C15.5322 13.6389 15.5015 13.574 15.4578 13.5181C15.1014 13.0511 14.6417 12.6728 14.1148 12.4129C13.5878 12.153 13.0079 12.0186 12.4204 12.02Z"
        fill="#808B99"
      />,
    ],
  },
  moreHorizontal: {
    viewBox: '0 0 16 4',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM6 2C6 0.9 6.9 0 8 0C9.1 0 10 0.9 10 2C10 3.1 9.1 4 8 4C6.9 4 6 3.1 6 2Z"
        fill="#566371"
      />,
    ],
  },
  moreVertical: {
    paths: [
      <circle cx="12" cy="4" r="2" fill="#051528" />,
      <circle cx="12" cy="12" r="2" fill="#051528" />,
      <circle cx="12" cy="20" r="2" fill="#051528" />,
    ],
  },
  pause: {
    paths: [
      <path
        d="M8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9V15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15V9Z"
        fill="white"
      />,
      <path
        d="M14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V9Z"
        fill="white"
      />,
    ],
  },
  edit: {
    viewBox: '0 0 16 16',
    paths: [
      <path
        d="M13.3335 9.77341V13.3334C13.3335 13.687 13.193 14.0262 12.943 14.2762C12.6929 14.5263 12.3538 14.6667 12.0002 14.6667H2.66683C2.31321 14.6667 1.97407 14.5263 1.72402 14.2762C1.47397 14.0262 1.3335 13.687 1.3335 13.3334V4.00008C1.3335 3.64646 1.47397 3.30732 1.72402 3.05727C1.97407 2.80722 2.31321 2.66675 2.66683 2.66675H6.22683"
        stroke="#808B99"
        fill="white"
        fillOpacity="0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M12.0002 1.33325L14.6668 3.99992L8.00016 10.6666H5.3335V7.99992L12.0002 1.33325Z"
        stroke="#808B99"
        fill="white"
        fillOpacity="0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  downwardArrow: {
    viewBox: '0 0 8 10',
    paths: [
      <path
        d="M4 1L4 9M4 9L1 6.03704M4 9L7 6.03704"
        stroke="#4991E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  upwardArrow: {
    viewBox: '0 0 8 10',
    paths: [
      <path
        d="M4 9L4 1M4 1L7 3.96296M4 1L1 3.96296"
        stroke="#4991E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  rightChevron: {
    viewBox: '0 0 7 12',
    paths: [
      <path
        d="M0.294703 11.2946C-0.0945693 10.9053 -0.0949133 10.2743 0.293935 9.88462L4.17009 6L0.293934 2.11538C-0.0949135 1.72569 -0.0945692 1.09466 0.294703 0.705384C0.684277 0.315811 1.3159 0.315811 1.70547 0.705384L7.00009 6L1.70547 11.2946C1.3159 11.6842 0.684277 11.6842 0.294703 11.2946Z"
        fill="#687688"
      />,
    ],
  },
  expandMore: {
    viewBox: '0 0 12 18',
    paths: [
      <path
        d="M11.2946 0.999537C10.9053 0.610265 10.2743 0.609921 9.88462 0.998769L6 4.87492L2.11538 0.998768C1.72569 0.609921 1.09466 0.610265 0.705384 0.999537C0.315811 1.38911 0.315811 2.02073 0.705385 2.41031L6 7.70492L11.2946 2.41031C11.6842 2.02073 11.6842 1.38911 11.2946 0.999537Z"
        fill="#566371"
      />,
    ],
  },
  search: {
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8737 13.6275C14.8661 13.6199 14.8558 13.6156 14.845 13.6156H14.2032L13.9742 13.3883C14.783 12.4451 15.2749 11.2224 15.2749 9.88277C15.2749 6.90481 12.861 4.49092 9.88307 4.49092C6.9051 4.49092 4.49121 6.90481 4.49121 9.88277C4.49121 12.8607 6.9051 15.2746 9.88307 15.2746C11.2227 15.2746 12.4446 14.7836 13.3878 13.9756L13.6167 14.2029V14.843C13.6167 14.8538 13.621 14.8641 13.6286 14.8718L17.1436 18.3819C17.4856 18.7233 18.0395 18.7231 18.3812 18.3814C18.7228 18.0399 18.7231 17.4862 18.3819 17.1442L14.8737 13.6275ZM9.88307 13.6156C7.82089 13.6156 6.15024 11.9449 6.15024 9.88277C6.15024 7.82142 7.82089 6.14995 9.88307 6.14995C11.9444 6.14995 13.6159 7.82142 13.6159 9.88277C13.6159 11.9449 11.9444 13.6156 9.88307 13.6156Z"
        fill="#8F98A4"
      />,
    ],
  },
  clearSearch: {
    paths: [
      <path
        d="M18.295 7.115C18.6844 6.72564 18.6844 6.09436 18.295 5.705C17.9056 5.31564 17.2744 5.31564 16.885 5.705L12 10.59L7.115 5.705C6.72564 5.31564 6.09436 5.31564 5.705 5.705C5.31564 6.09436 5.31564 6.72564 5.705 7.115L10.59 12L5.705 16.885C5.31564 17.2744 5.31564 17.9056 5.705 18.295C6.09436 18.6844 6.72564 18.6844 7.115 18.295L12 13.41L16.885 18.295C17.2744 18.6844 17.9056 18.6844 18.295 18.295C18.6844 17.9056 18.6844 17.2744 18.295 16.885L13.41 12L18.295 7.115Z"
        fill="#566371"
      />,
    ],
  },
  addUser: {
    viewBox: '0 0 16 16',
    fill: 'none',
    paths: [
      <path
        d="M10.222 13.0001V11.889C10.222 11.2996 9.98788 10.7344 9.57113 10.3176C9.15438 9.90087 8.58915 9.66675 7.99978 9.66675H4.11089C3.52152 9.66675 2.95629 9.90087 2.53955 10.3176C2.1228 10.7344 1.88867 11.2996 1.88867 11.889V13.0001"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M6.05523 7.44444C7.28253 7.44444 8.27745 6.44952 8.27745 5.22222C8.27745 3.99492 7.28253 3 6.05523 3C4.82793 3 3.83301 3.99492 3.83301 5.22222C3.83301 6.44952 4.82793 7.44444 6.05523 7.44444Z"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M12.4434 5.77759V9.11092"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M14.1107 7.44409H10.7773"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  success: {
    viewBox: '0 0 26 26',
    paths: [
      <circle
        cx="13"
        cy="13"
        r="12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M9 13.1666L11.4401 15.6666L17.6667 10.3333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  warning: {
    viewBox: '0 0 26 26',
    paths: [
      <circle
        cx="13"
        cy="13"
        r="12"
        stroke={Colors.darkBlue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M13.1299 11.9996L13.1988 18.4126"
        stroke={Colors.darkBlue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M13.1299 8.06339L13 8.06476"
        stroke={Colors.darkBlue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  error: {
    viewBox: '0 0 26 26',
    paths: [
      <circle
        cx="13"
        cy="13"
        r="12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M9.46524 9.4604L16.5358 16.5309"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M16.5342 9.45882L9.4663 16.532"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  share: {
    viewBox: '0 0 16 16',
    fill: 'none',
    paths: [
      <path
        d="M8.84978 5.95865L9.56516 5.92559V5.20944V3.22199L14.4318 8.00008L9.56516 12.7782V10.8069V10.031L8.78976 10.0573C6.07344 10.1494 3.50986 11.1069 1.45982 12.7966C1.85778 9.08377 4.98188 6.13737 8.84978 5.95865ZM14.6891 7.74744L14.6888 7.74771L14.6891 7.74744ZM9.22161 13.5886L9.22241 13.5894L9.22161 13.5886Z"
        stroke={Colors.grayishBlue}
        strokeWidth="1.5"
      />,
    ],
  },
  add: {
    viewBox: '0 0 16 16',
    fill: 'none',
    paths: [
      <path
        d="M5.33333 8H10.6667M2 2H14V14H2V2ZM8 5.33333V10.6667V5.33333Z"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  shareTopCandidates: {
    viewBox: '0 0 24 24',
    paths: [
      <path
        d="M17 7H13V9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z"
        fill="#051528"
      />,
      <path
        d="M11 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15Z"
        fill="#051528"
      />,
      <path d="M8 11H16V13H8V11Z" fill="#051528" />,
    ],
  },
  shareList: {
    viewBox: '0 0 16 16',
    fill: 'none',
    paths: [
      <path
        d="M12 9.33333V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.6 2.6 4 3.33333 4H6.66667M10 2H14V6M6.66667 9.33333L13.4667 2.53333"
        stroke="#566371"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  copy: {
    viewBox: '0 0 17 16',
    paths: [
      <path
        d="M13.8333 6H7.83333C7.09695 6 6.5 6.59695 6.5 7.33333V13.3333C6.5 14.0697 7.09695 14.6667 7.83333 14.6667H13.8333C14.5697 14.6667 15.1667 14.0697 15.1667 13.3333V7.33333C15.1667 6.59695 14.5697 6 13.8333 6Z"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
        fillOpacity={0}
      />,
      <path
        d="M3.83301 10H3.16634C2.81272 10 2.47358 9.85956 2.22353 9.60952C1.97348 9.35947 1.83301 9.02033 1.83301 8.66671V2.66671C1.83301 2.31309 1.97348 1.97395 2.22353 1.7239C2.47358 1.47385 2.81272 1.33337 3.16634 1.33337H9.16634C9.51996 1.33337 9.8591 1.47385 10.1092 1.7239C10.3592 1.97395 10.4997 2.31309 10.4997 2.66671V3.33337"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
        fillOpacity={0}
      />,
    ],
  },
  removeFromList: {
    viewBox: '0 0 16 16',
    paths: [
      <g clipPath="url(#clip0)">
        <path
          d="M2.66699 4H13.3337"
          stroke="#808B99"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.66699 8H13.3337"
          stroke="#808B99"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.66699 12H7.33366"
          stroke="#808B99"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.333 12.6667L13.333 10.6667"
          stroke="#808B99"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.333 10.6666L13.333 12.6666"
          stroke="#808B99"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>,
    ],
  },
  shareSample: {
    viewBox: '0 0 16 16',
    paths: [
      <path
        d="M6.92578 8.53696C7.15635 8.8452 7.45051 9.10025 7.78832 9.28481C8.12612 9.46937 8.49967 9.57912 8.88362 9.60662C9.26757 9.63411 9.65295 9.57872 10.0136 9.44418C10.3743 9.30964 10.7018 9.09912 10.9739 8.82688L12.5846 7.21621C13.0736 6.70992 13.3441 6.03183 13.338 5.32798C13.3319 4.62413 13.0496 3.95084 12.5519 3.45312C12.0542 2.95541 11.3809 2.67309 10.677 2.66697C9.97316 2.66086 9.29507 2.93143 8.78878 3.42042L7.86533 4.3385"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
        fillOpacity={0}
      />,
      <path
        d="M9.07347 7.46324C8.84291 7.15499 8.54874 6.89994 8.21094 6.71538C7.87313 6.53083 7.49959 6.42107 7.11564 6.39358C6.73168 6.36608 6.34631 6.42148 5.98565 6.55601C5.62499 6.69055 5.29749 6.90108 5.02535 7.17332L3.41469 8.78398C2.92569 9.29027 2.65512 9.96836 2.66123 10.6722C2.66735 11.3761 2.94967 12.0494 3.44739 12.5471C3.9451 13.0448 4.61839 13.3271 5.32224 13.3332C6.02609 13.3393 6.70419 13.0688 7.21048 12.5798L8.12855 11.6617"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
        fillOpacity={0}
      />,
    ],
  },
  indicatorActive: {
    viewBox: '0 0 8 8',
    paths: [<circle cx="4" cy="4" r="4" style={{ fill: Colors.secondary }} />],
  },
  indicatorDraft: {
    viewBox: '0 0 8 8',
    paths: [
      <circle
        cx="4"
        cy="4"
        r="3.5"
        style={{ stroke: Colors.grayishBlue }}
        fill="white"
        fillOpacity={0}
      />,
    ],
  },
  indicatorInactive: {
    viewBox: '0 0 8 8',
    paths: [
      <circle cx="4" cy="4" r="4" style={{ fill: Colors.grayishBlue }} />,
    ],
  },
  tick: {
    viewBox: '0 0 10 9',
    paths: [
      <path
        d="M1 5L3.5 7.5L9 1"
        stroke="#808B99"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillOpacity={0}
      />,
    ],
  },
  checkedList: {
    viewBox: '0 0 20 20',
    fill: 'none',
    paths: [
      <path
        d="M3.33301 5H16.6663"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M3.33301 10H16.6663"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M3.33301 15H9.16634"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M16.667 13.3333L14.167 15.8333L12.917 14.5833"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  redo: {
    paths: [
      <path
        d="M13.2857 4C9.02571 4 5.57143 7.45429 5.57143 11.7143H3L6.42857 15.1343L9.85714 11.7143H7.28571C7.28571 8.39714 9.96857 5.71429 13.2857 5.71429C16.6029 5.71429 19.2857 8.39714 19.2857 11.7143C19.2857 15.0314 16.6029 17.7143 13.2857 17.7143C11.6314 17.7143 10.1314 17.0371 9.05143 15.9486L7.83429 17.1657C9.23143 18.5629 11.1514 19.4286 13.2857 19.4286C17.5457 19.4286 21 15.9743 21 11.7143C21 7.45429 17.5457 4 13.2857 4Z"
        fill="#333333"
      />,
    ],
  },
  comment: {
    viewBox: '0 0 18 18',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00007 1.5H15.0001C15.8251 1.5 16.5001 2.175 16.5001 3V12C16.5001 12.825 15.8251 13.5 15.0001 13.5H4.50007L1.50757 16.5V3C1.50757 2.175 2.17507 1.5 3.00007 1.5ZM13.5001 6.75H4.50007V8.25H13.5001V6.75ZM10.5001 10.5H4.50007V9H10.5001V10.5ZM4.50007 6H13.5001V4.5H4.50007V6Z"
        fill="#333333"
      />,
    ],
  },
  download: {
    viewBox: '0 0 16 16',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99998 9.34961C2.35896 9.34961 2.64998 9.64062 2.64998 9.99961V12.6663C2.64998 12.8475 2.72197 13.0213 2.85012 13.1495C2.97827 13.2776 3.15208 13.3496 3.33331 13.3496H12.6666C12.8479 13.3496 13.0217 13.2776 13.1498 13.1495C13.278 13.0213 13.35 12.8475 13.35 12.6663V9.99961C13.35 9.64062 13.641 9.34961 14 9.34961C14.359 9.34961 14.65 9.64062 14.65 9.99961V12.6663C14.65 13.1923 14.441 13.6968 14.0691 14.0687C13.6971 14.4407 13.1927 14.6496 12.6666 14.6496H3.33331C2.8073 14.6496 2.30283 14.4407 1.93088 14.0687C1.55893 13.6968 1.34998 13.1923 1.34998 12.6663V9.99961C1.34998 9.64062 1.64099 9.34961 1.99998 9.34961Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.20698 6.20698C4.46082 5.95314 4.87238 5.95314 5.12622 6.20698L7.99993 9.0807L10.8736 6.20698C11.1275 5.95314 11.539 5.95314 11.7929 6.20698C12.0467 6.46082 12.0467 6.87238 11.7929 7.12622L8.45955 10.4596C8.33766 10.5815 8.17233 10.6499 7.99993 10.6499C7.82754 10.6499 7.66221 10.5815 7.54032 10.4596L4.20698 7.12622C3.95314 6.87238 3.95314 6.46082 4.20698 6.20698Z"
        fill="#808B99"
      />,
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 1.34961C8.35896 1.34961 8.64998 1.64062 8.64998 1.99961V9.99961C8.64998 10.3586 8.35896 10.6496 7.99998 10.6496C7.64099 10.6496 7.34998 10.3586 7.34998 9.99961V1.99961C7.34998 1.64062 7.64099 1.34961 7.99998 1.34961Z"
        fill="#808B99"
      />,
    ],
  },
  downloadMedia: {
    viewBox: '0 0 24 24',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.54239 18.4453C6.19511 18.0901 6 17.6084 6 17.1061L6 14.6818C6 14.3053 6.29848 14 6.66667 14C7.03486 14 7.33333 14.3053 7.33333 14.6818L7.33333 17.1061C7.33333 17.2467 7.38796 17.3816 7.4852 17.481C7.58244 17.5805 7.71433 17.6364 7.85185 17.6364L16.1481 17.6364C16.4318 17.6364 16.6667 17.3962 16.6667 17.1061L16.6667 14.6818C16.6667 14.3053 16.9651 14 17.3333 14C17.7015 14 18 14.3053 18 14.6818L18 17.1061C18 18.1493 17.1682 19 16.1481 19L7.85185 19C7.36071 19 6.88968 18.8005 6.54239 18.4453Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M15.7848 10.1435C16.0717 10.4518 16.0717 10.9517 15.7848 11.26L12.5195 14.7688C12.2326 15.0771 11.7674 15.0771 11.4805 14.7688L8.21519 11.26C7.92827 10.9517 7.92827 10.4518 8.21519 10.1435C8.5021 9.8352 8.96729 9.8352 9.2542 10.1435L11.2653 12.3046L11.2653 5.78947C11.2653 5.35346 11.5942 5 12 5C12.4058 5 12.7347 5.35346 12.7347 5.78947L12.7347 12.3046L14.7458 10.1435C15.0327 9.8352 15.4979 9.8352 15.7848 10.1435Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  stopMedia: {
    viewBox: '0 0 24 24',
    paths: [
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8H8L8 16H16V8ZM8 6C6.89543 6 6 6.89543 6 8V16C6 17.1046 6.89543 18 8 18H16C17.1046 18 18 17.1046 18 16V8C18 6.89543 17.1046 6 16 6H8Z"
        fill="white"
      />,
    ],
  },
  invited: {
    fill: 'none',
    viewBox: '0 0 20 20',
    paths: [
      <path
        d="M4 8V15H16V8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M4 8L10 4L16 8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M12 11L16 9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M8 11L4 9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M4 15L7.87868 11.1213C9.05025 9.94975 10.9497 9.94975 12.1213 11.1213L16 15"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  applied: {
    fill: 'none',
    viewBox: '0 0 20 20',
    paths: [
      <path
        d="M8 10.7143L9.2 12L12 9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <circle
        cx="10"
        cy="10"
        r="6"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  saved: {
    viewBox: '5 0 20 20',
    paths: [
      <path
        d="M8 7C8 5.34315 9.34315 4 11 4H15C16.6569 4 18 5.34315 18 7V16L13 12.4706L8 16V7Z"
        fill
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  offer: {
    fill: 'none',
    viewBox: '0 0 16 16',
    paths: [
      <path
        d="M4 7H11"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M4 10H11"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <rect
        x="1"
        y="2"
        width="13"
        height="13"
        rx="2"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  offers: {
    fill: 'none',
    viewBox: '0 0 16 16',
    paths: [
      <path
        d="M3.5 8.5H8.5"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M3.5 11.5H8.5"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M11 12H13C14.1046 12 15 11.1046 15 10V4C15 2.89543 14.1046 2 13 2H7C5.89543 2 5 2.89543 5 4V5"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <rect
        x="1"
        y="5"
        width="10"
        height="10"
        rx="2"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  offerDeclined: {
    fill: 'none',
    viewBox: '0 0 19 19',
    paths: [
      <path
        d="M3.5 8.5H8.5"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M3.5 11.5H8.5"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M5 5V4C5 2.89543 5.89543 2 7 2H13C14.1046 2 15 2.89543 15 4V7"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M11 8.5V7C11 5.89543 10.1046 5 9 5H3C1.89543 5 1 5.89543 1 7V13C1 14.1046 1.89543 15 3 15H7.5"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M15.1703 9.05653C15.4114 9.2977 15.4114 9.68871 15.1703 9.92988L12.9869 12.1133L15.1703 14.2967C15.4114 14.5378 15.4114 14.9289 15.1703 15.17C14.9291 15.4112 14.5381 15.4112 14.2969 15.17L12.1135 12.9866L9.93011 15.17C9.68894 15.4112 9.29793 15.4112 9.05676 15.17C8.81558 14.9289 8.81558 14.5378 9.05676 14.2967L11.2402 12.1133L9.05676 9.92988C8.81558 9.68871 8.81558 9.2977 9.05676 9.05653C9.29793 8.81535 9.68894 8.81535 9.93011 9.05653L12.1135 11.2399L14.2969 9.05653C14.5381 8.81535 14.9291 8.81535 15.1703 9.05653Z"
        fill="#808B99"
      />,
    ],
  },
  downArrow: {
    fill: 'none',
    viewBox: '0 0 10 6',
    paths: [
      <path
        d="M1 1L5 5L9 1"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  plus: {
    fill: 'none',
    viewBox: '0 0 16 16',
    paths: [
      <path
        d="M8 3.33301V12.6663"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M3.33301 8H12.6663"
        stroke="#808B99"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  hamburger: {
    fill: 'none',
    viewBox: '0 0 26 26',
    paths: [
      <path
        d="M3 5H21"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M3 12H21"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M3 19H21"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  backArrow: {
    fill: 'none',
    viewBox: '0 0 16 12',
    paths: [
      <path
        d="M15 5.99935H2M5.00003 1L1 5.99935L4.62503 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  filters: {
    fill: 'none',
    viewBox: '0 0 24 24',
    paths: [
      <path
        d="M4.00043 4.88867L10.2227 4.88867"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M13.7778 4.88867L20 4.88867"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M4 12L12 12"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M15.5556 12L20 12"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M4.00087 19.1108L8.44531 19.1108"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M12 19.1108L20 19.1108"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M10.2227 2.22217L10.2227 7.5555"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M15.5547 9.3335L15.5547 14.6668"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M8.44531 16.4443L8.44531 21.7777"
        stroke="#566371"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
  microphone: {
    fill: 'none',
    viewBox: '0 0 28 28',
    paths: [
      <path
        fill="none"
        d="M19.0136 5.18399C19.0136 2.47958 17.2447 0.285713 13.9998 0.285713C10.7513 0.285713 9.09973 2.47958 9.09973 5.18399V6.35234H19.0127V5.18399H19.0136Z"
      />,
      <path
        fill="none"
        d="M13.9998 17.9186C17.2447 17.9186 19.0136 15.7265 19.0136 13.0221V7.20855H9.09973V13.0212C9.09973 15.7265 10.7513 17.9186 13.9998 17.9186Z"
      />,
      <path
        fill="none"
        d="M20.8576 6.16365V13.0221C20.8576 16.8032 18.3207 19.8788 14 19.8788C9.67926 19.8788 7.14239 16.8032 7.14239 13.0221V6.16365C6.04987 5.07113 5.18396 6.16365 5.18396 6.16365V13.0036C5.18396 13.0098 5.18396 13.0151 5.18396 13.0221C5.18396 17.5589 8.61319 21.2932 13.0203 21.7808V24.8238L9.11581 24.8326L8.12028 27.7143H19.5569L18.5826 24.8212L14.9787 24.8221V21.779C19.3876 21.2905 22.8151 17.5571 22.8151 13.0204H22.8169V6.16365C21.6141 4.96355 20.8576 6.16365 20.8576 6.16365Z"
      />,
    ],
  },
  maximize: {
    fill: 'none',
    viewBox: '0 0 24 24',
    paths: [
      <path
        d="M14.6667 4H20.0001V9.33333"
        stroke="#808B99"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M9.33333 20.0001H4V14.6667"
        stroke="#808B99"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M20.0001 4L13.7778 10.2222"
        stroke="#808B99"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
      <path
        d="M4 20.0001L10.2222 13.7778"
        stroke="#808B99"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />,
    ],
  },
};
